const labelClassName = "text-sm text-gray-700";
const inputClassName = "border-gray-300 bg-white shadow-sm";
const formInputClassName = "flex flex-col gap-1.5";
const checkboxContainerClassName = "flex-1 flex flex-row items-center gap-2";
const checkboxClassName =
  "data-[state=checked]:bg-primary-blue data-[state=checked]:border-primary-blue flex size-5 items-center justify-center rounded-[6px] border-gray-300 bg-white text-white";
const radioClassName = `${checkboxClassName} rounded-full`;

export {
  labelClassName,
  inputClassName,
  formInputClassName,
  checkboxContainerClassName,
  checkboxClassName,
  radioClassName,
};
